<template>
    <div>
        <!-- <div>
            <button @click="printEditorHtml">print html</button>
            <button @click="insertTextHandler">insert text</button>
            <button @click="disableHandler">disable</button>
        </div> -->
        <div  style="border: 1px solid #ccc; margin-top: 10px;">
            <!-- 工具栏 -->
            <Toolbar
                style="border-bottom: 1px solid #ccc"
                :editor="editor"
                :defaultConfig="toolbarConfig"
            />
            <!-- 编辑器 -->
            <Editor
            :style="{height:params.editorHeight ? params.editorHeight+'px' : '250px'}"
                style="overflow-y: hidden;"
                :defaultConfig="editorConfig"
                v-model="params.value"
                @onChange="onChange"
                @onCreated="onCreated"
                @onBlur="onBlur"
            />
        </div>
        <!-- <div style="margin-top: 10px;">
            <textarea
                v-model="html"
                readonly
                style="width: 100%; height: 200px; outline: none;"
            ></textarea>
        </div> -->
    </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import Cookies from 'js-cookie'
export default {
    name: 'MyEditor',
    components: { Editor, Toolbar },
    props: {
            params: {
                type: Object,
                default: function(){
                    return {}
                }
            },
        },
    data() {
        return {
            editor: null,
            html: '',
            toolbarConfig: {
                // toolbarKeys: [ /* 显示哪些菜单，如何排序、分组 */ ],
                // excludeKeys: [ /* 隐藏哪些菜单 */ ],
            },
            editorConfig: {
                placeholder: '请输入内容...',
                // autoFocus: false,

                // 所有的菜单配置，都要在 MENU_CONF 属性下
                MENU_CONF: {
                    uploadImage:{
                        server: 'https://crmgate.efenda.cn/minio/upload?type=0&fileType=1',
                        // 跨域是否传递 cookie ，默认为 false
                        fieldName:'file',
                        headers: {
                            Authorization: Cookies.get('loginToken')
                        },
                        customInsert(res, insertFn) {                  // JS 语法
                            // res 即服务端的返回结果
                            console.log("上传图片富文本返回数据",res)
                            // 从 res 中找到 url alt href ，然后插入图片
                            let url = res.data.url || "";
                            let name = res.data.name || "";
                            insertFn(url, name, url)
                        },
                    }
                }
            }
        }
    },
    created () {
        console.log("富文本编辑器",this.params)
    },
    methods: {
        onCreated(editor) {
            this.editor = Object.seal(editor) // 【注意】一定要用 Object.seal() 否则会报错
            if(this.params.disabled){
                this.editor.disable();
                console.log("富文本禁用")
            }
            console.log("富文本实例",this.editor,this.params.disabled)
        },
        onChange(editor) {
          
            let htmlValue= editor.getHtml() || "";
            this.params.value = htmlValue;
            console.log('onChange', editor.getHtml(),htmlValue,editor.children) // onChange 时获取编辑器最新内容
        },
        
        onBlur(editor) { 
            // this.params.value = editor.getHtml() || "";
            console.log('onBlur', editor,this.params.value) 
        },
        insertTextHandler() {
            const editor = this.editor
            if (editor == null) return
            editor.insertText(' hello ')
        },
        printEditorHtml() {
            const editor = this.editor
            if (editor == null) return
            console.log(editor.getHtml())
        },
        disableHandler() {
            const editor = this.editor
            if (editor == null) return
            editor.disable()
        },
    },
    mounted() {
        // 模拟 ajax 请求，异步渲染编辑器
        // setTimeout(() => {
        //     this.html = '<p>Ajax 异步设置内容 HTML</p>'
        // }, 1500)
    },
    
    destroyed () {
        
        this.$off();
    },
}
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>



// WEBPACK FOOTER //
// src/components/editor/MyEditor.vue